(function() {

    'use strict';


    /**
     * This is the content of the Video.js bundle, which decides what player version to serve based on browser features detection.
     */


    // already defined? exit!
    if (window.SAPO && (
             window.SAPO._loadingVideoBundle ||
            (window.SAPO.Project && window.SAPO.Project.Video) ) ) {
        return;
    }



    if (typeof SAPO === 'undefined') {
        window.SAPO = {
            _loadingVideoBundle: true
        };
    }
    else {
        window.SAPO = window.SAPO;
    }


    // detect video element support
    var supportsVideoElement = false;
    var canPlayH264 = false;
    (function() {
        var el = document.createElement('video');
        supportsVideoElement = !!el.play;
        if (supportsVideoElement) {
            canPlayH264 = !!( el.canPlayType('video/mp4; codecs="avc1.42E01E"').replace(/^no$/, '') );
        }
    })();



    // detect flash support
    var hasFlash;
    (function() {
        /*global ActiveXObject:false */
        // http://www.jquery4u.com/snippets/jquery-check-flash-enabled/
        // https://code.google.com/p/swfobject/source/browse/trunk/swfobject/src/swfobject.js line 48
        var hf = false;
        try {
            var fo = new ActiveXObject('ShockwaveFlash.ShockwaveFlash');
            if (fo) { hf = true; }
        }
        catch (ex) {
            try {
                var plug = navigator.mimeTypes['application/x-shockwave-flash'];
                if (plug && plug.enabledPlugin) {
                    hf = true;
                }
            }
            catch (ex2) {}
        }
        hasFlash = hf;
    })();



    var bundle = 'VideoHighEnd';
    var ua = navigator.userAgent.toLowerCase();

    //if (/(msie)/i.test(ua) && ua.replace(/(.*)\smsie\s([^;]+);(.*)/, '$2') < 8) { // SAPO.Browser.IE && SAPO.Browser.version < 8
    if ( (!supportsVideoElement && hasFlash) &&
         (/(msie)/i.test(ua) && parseFloat(ua.replace(/(.*)\smsie\s([^;]+);(.*)/, '$2')) < 8) // SAPO.Browser.IE && SAPO.Browser.version < 8
    ) {
        bundle = 'VideoFlash';
    }
    /*else if (supportsVideoElement &&
        canPlayH264 &&
        /android 2/g.test(ua)) {
            bundle = 'VideoNative';
    }*/


    var headEl = document.getElementsByTagName('head')[0];
    var bodyEl = document.getElementsByTagName('body')[0];


    var delayedLoadVar;


    // determine domain and location of this script in the HTML document
    var fetchDomain = function() {
        var fetchDomainAux = function(rootEl) {
            if (!rootEl) { return; }
            var m, i, f, src, scriptEl;
            var scriptEls = rootEl.getElementsByTagName('script');

            //var r = /\/\/(.+sapo\.pt)\/Bundles\/Video.js/g;
            var r = new  RegExp('\/\/(.+)\/Projects\/Video\/' + SV_VERSION + '\/Video.js', 'g');
            // var r = /\/Bundles\/Video.js/g; // JUST FOR TESTS

            for (i = 0, f = scriptEls.length; i < f; ++i) {
                scriptEl = scriptEls[i];
                src = scriptEl.getAttribute('src');
                m = r.exec(src);
                if (m) {
                    delayedLoadVar = scriptEl.getAttribute('data-delayed-load');
                    var implementations = scriptEl.getAttribute('data-implementations');

                    if (implementations) {
                        implementations = implementations.split(/,\s*/);
                        for (var j = 0, J = implementations.length, impl; j < J; ++j) {
                            impl = implementations[j].toLowerCase().replace(/^\s+|\s+$|\n+$/g, ''); // trim polyfill inline
                            implementations[j] = impl;
                        }

                        //console.log('implementationOrder', implementationOrder);
                        window.SAPO._videoImplementations = implementations;
                    }

                    return m[1];
                }
                r.lastIndex = 0;
            }
        };


        var domain = fetchDomainAux(headEl);
        if (!domain) {
            domain = fetchDomainAux(bodyEl);
        }

        // return domain || '10.134.130.222'; // ONLY for tests
        return domain || SV_VERSION; // PROD
    };



    var domain = fetchDomain();

    var loadResources = function() {
        // fetch bundle...
        var scriptEl = document.createElement('script');
        scriptEl.setAttribute('type', 'text/javascript');
        scriptEl.setAttribute('src', ['//', domain, '/Projects/Video/' + SV_VERSION + '/', bundle, '.js'].join(''));


        var linkEl;
        if (bundle === 'VideoNative') {
            linkEl = document.createElement('link');
            linkEl.setAttribute('rel', 'stylesheet');
            linkEl.setAttribute('type', 'text/css');
            linkEl.setAttribute('href', ['//', domain, '/Projects/Video/' + SV_VERSION + '/css/native.css'].join(''));
        }

        if (document.readyState !== 'complete' && !document.body) { // TODO CHECK THIS
            document.write(scriptEl.outerHTML);
            if (linkEl) {
                document.write(linkEl.outerHTML);
            }
        }
        else {
            headEl.appendChild(scriptEl); // REMEMBER THIS IS ASYNCHRONOUS!

            if (linkEl) {
                headEl.appendChild(linkEl);
            }
        }
    };

    if (delayedLoadVar) {
        window[delayedLoadVar] = {
            bundle: bundle,

            load: function(cb) {
                var timer;
                var checkReady = function() {
                    if (!(window.SAPO && SAPO.Project && SAPO.Project.Video)) { return; }
                    clearInterval(timer);

                    // WOW IE8 - http://stackoverflow.com/questions/1073414/deleting-a-window-property-in-ie
                    window[delayedLoadVar] = undefined;
                    try {
                        delete window[delayedLoadVar];
                    } catch (ex) {}

                    cb();
                };

                loadResources();
                timer = setInterval(checkReady, 500);
            }
        };
    }
    else {
        loadResources();
    }



})();
